import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Button
} from '@mui/material';
import axios from 'axios';

const StockDialog = ({ openPopup, setOpenPopup }) => {
  const productStockDetails = openPopup.productStockDetails;

  const [reOrderQty, setReOrderQty] = useState('');
  const [replanishedQty, setReplanishedQty] = useState('');

  useEffect(() => {
    if (productStockDetails) {
      setReOrderQty(productStockDetails.reOrderQty ?? '');
      setReplanishedQty(productStockDetails.replanishedQty ?? '');
    } else {
      setReOrderQty('');
      setReplanishedQty('');
    }
  }, [productStockDetails]);

  const handleClose = () => {
    setReOrderQty('');
    setReplanishedQty('');
    setOpenPopup({ isOpen: false, docno: undefined, size: undefined, productStockDetails: undefined });
  };

  const saveStockDetails = async(payload) => {
    const config = {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    };
    try {
        const response = await axios.post("productsController/saveProductStock", payload, config);
        if (response.data) {
            alert(response.data);
            openPopup.callBack();
        }
    } catch (error) {
        alert("Server Error ! 👎");
    }
  }

  const handleSubmit = () => {
    let openingCalQty = (productStockDetails?.openingStockQty ?? 0) + parseInt(replanishedQty);
    const payload = {
      docno: openPopup.docno,
      size: openPopup?.size ?? null,
      openingStockQty: openingCalQty > 0 ? openingCalQty : 0,
      reOrderQty: parseInt(reOrderQty),
      replanishedQty: parseInt(replanishedQty),
    };
    console.log(productStockDetails ? 'Update:' : 'Add:', payload);
    saveStockDetails(payload);
    // TODO: Call your API here
    handleClose();
  };

  return (
    <Dialog open={openPopup.isOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {(productStockDetails ? 'Update Stock Details' : 'Add Stock Details') + (openPopup.docno ? ` ---> ${openPopup.docno}` : '') +  (openPopup?.size ? ` ---> ${openPopup?.size}`: '')}
      </DialogTitle>
      <DialogContent dividers>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>Opening Stock QTY</TableCell>
              <TableCell>
                {productStockDetails?.openingStockQty ?? 'N/A'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Re-Order QTY</TableCell>
              <TableCell>
                <TextField
                  type="number"
                  value={reOrderQty}
                  onChange={(e) => setReOrderQty(e.target.value)}
                  fullWidth
                  inputProps={{ min: 0 }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Replenished Stock QTY</TableCell>
              <TableCell>
                <TextField
                  type="number"
                  value={replanishedQty}
                  onChange={(e) => setReplanishedQty(e.target.value)}
                  fullWidth
                //   inputProps={{ min: 0 }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          {productStockDetails ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockDialog;
